module.exports = __webpack_public_path__ + "static/media/sfx_ui_pop_up_times_up.8ba67dea.mp3";